// Campaign attribution. Captures UTMs on first landing and holds them for the
// session so a click to /pricing and back doesn't lose where the lead came from.
const KEY = 'ubotika_attribution';
const FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'gbraid', 'wbraid', 'fbclid'];

export function readAttribution() {
  if (typeof window === 'undefined') return {};
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || '{}');
  } catch (e) {
    return {};
  }
}

export function captureAttribution() {
  if (typeof window === 'undefined') return {};
  try {
    const params = new URLSearchParams(window.location.search);
    const incoming = {};
    FIELDS.forEach((f) => {
      const v = params.get(f);
      if (v) incoming[f] = v.slice(0, 200);
    });

    const stored = readAttribution();
    // First touch wins: an internal navigation must not blank out the original ad.
    if (Object.keys(incoming).length === 0) return stored;

    const merged = { ...incoming, landedAt: stored.landedAt || new Date().toISOString() };
    sessionStorage.setItem(KEY, JSON.stringify(merged));
    return merged;
  } catch (e) {
    return {};
  }
}

// Fires the conversion pixels the site already runs, plus LinkedIn.
export function trackLead({ source, landingPath }) {
  if (typeof window === 'undefined') return;
  const utm = readAttribution();
  try {
    if (window.gtag) {
      window.gtag('event', 'lead_submit', { source, landing_path: landingPath, ...utm });
      window.gtag('event', 'conversion', { send_to: 'AW-18245536456/Pz-jCJ6LtsAcEMiVk_xD' });
    }
    if (window.fbq) window.fbq('track', 'Lead', { content_name: source });
    // LinkedIn conversion — only fires once a real conversion ID is set in
    // public/index.html. See the PLACEHOLDER note there.
    if (window.lintrk && window.UBOTIKA_LI_CONVERSION_ID) {
      window.lintrk('track', { conversion_id: window.UBOTIKA_LI_CONVERSION_ID });
    }
  } catch (e) {
    /* tracking must never break a submit */
  }
}
